export const userDropdownMessages = {
  en: {
    userDropdownMessages: {
      clickToChange: 'Click to Change',
      signOut: 'Sign Out',
      support: 'Support',
      account: 'Supplios Account',
    },
  },
  es: {
    userDropdownMessages: {
      clickToChange: 'Haga clic para cambiar',
      signOut: 'Cerrar sesión',
      support: 'Soporte',
      account: 'Cuenta de Supplios',
    },
  },
  pt: {
    userDropdownMessages: {
      clickToChange: 'Clique para alterar',
      signOut: 'Sair',
      support: 'Suporte',
      account: 'Conta Supplios',
    },
  },
  'zh-Hans': {
    userDropdownMessages: {
      clickToChange: '点击更改',
      signOut: '登出',
      support: '支持',
      account: 'Supplios 账户',
    },
  },
  'zh-Hant': {
    userDropdownMessages: {
      clickToChange: '點擊更改',
      signOut: '登出',
      support: '支援',
      account: 'Supplios 帳戶',
    },
  },
};
